/* eslint-disable jira/naming/disallow-filenames */
import React from 'react';
import type ServicedeskOpsgenieScheduleType from '@jira/spa-apps__servicedesk-opsgenie-schedule/src/OpsgenieScheduleApp.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';

export const LazyServicedeskOpsgenieSchedule: LazyComponent<() => React.JSX.Element> = lazyForPaint<
	typeof ServicedeskOpsgenieScheduleType
>(
	() =>
		import(
			/* webpackChunkName: "async-servicedesk-opsgenie-schedule", jiraSpaEntry: "async-servicedesk-opsgenie-schedule" */ '@jira/spa-apps__servicedesk-opsgenie-schedule/src/ServicedeskOpsgenieSchedule.tsx'
		),
);

const AsyncServicedeskOpsgenieSchedule = (): React.JSX.Element => (
	<LazyPage
		Page={LazyServicedeskOpsgenieSchedule}
		pageId="spa-apps/servicedesk/opsgenie-schedule"
		shouldShowSpinner
	/>
);

export default AsyncServicedeskOpsgenieSchedule;
